import { RoundTripCyclePicker, type PlaybackCycle } from './RoundTripCycles'

/** TRIPS tab body. Replay is always a whole round trip: it starts when the truck leaves
 *  Dhar and, until the truck is back in Dhar, runs live up to now. (Single hub-to-hub leg
 *  replay was removed on request, 2026-11-03 -- a leg is a fragment of the trip ops track.) */
export function ReplayTripsPanel({
  activeId, onPickCycle,
}: {
  activeId?: string | null
  onPickCycle: (c: PlaybackCycle) => void
}): JSX.Element {
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-2">
      <p className="shrink-0 px-0.5 text-[11px] text-[#64748B]">
        Round trips from GPS: starts when the truck leaves Dhar → Jhulwaniya → Dhule → Jhulwaniya → back to Dhar.
        Not back in Dhar yet = live, plays up to where it is now.
      </p>
      <RoundTripCyclePicker activeId={activeId} onPick={onPickCycle} />
    </div>
  )
}
